export const toggleButton = (button: HTMLElement, newInnerHtml: string, callback?: () => void): void => {
    const textLabels = button.querySelectorAll<HTMLElement>('.j-button__label');
    const originalInnerHtml = textLabels[0]!.innerHTML;
    let isOriginal = true;

    button.addEventListener('click', (): void => {
        if (callback) {
            // eslint-disable-next-line callback-return
            callback();
        }

        if (isOriginal) {
            changeButtonInner(button, newInnerHtml);
        } else {
            changeButtonInner(button, originalInnerHtml!);
        }
        isOriginal = !isOriginal;
    });
};

export const changeButtonInner = (button: HTMLElement, newInnerHtml: string): void => {
    const textLabels = button.querySelectorAll<HTMLElement>('.j-button__label');

    textLabels.forEach((label: HTMLElement) => {
        label.innerHTML = newInnerHtml;
    });
};

